export default __webpack_public_path__ + "static/media/live_arr.77e94073.svg";